var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_17665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 1.75H11.125V0.5H4.875V1.75H3.625C2.59113 1.75 1.75 2.59113 1.75 3.625V14.625C1.75 15.6589 2.59113 16.5 3.625 16.5H12.375C13.4089 16.5 14.25 15.6589 14.25 14.625V3.625C14.25 2.59113 13.4089 1.75 12.375 1.75ZM6.125 1.75H9.875V3H6.125V1.75ZM13 14.625C13 14.9696 12.7196 15.25 12.375 15.25H3.625C3.28038 15.25 3 14.9696 3 14.625V3.625C3 3.28038 3.28038 3 3.625 3H4.875V4.25H11.125V3H12.375C12.7196 3 13 3.28038 13 3.625V14.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.375C6.27684 5.375 4.875 6.77688 4.875 8.5C4.875 10.2231 6.27684 11.625 8 11.625C9.72316 11.625 11.125 10.2231 11.125 8.5C11.125 6.77688 9.72316 5.375 8 5.375ZM9.875 8.5C9.875 8.78909 9.80912 9.06309 9.69175 9.30787L8.625 8.24113V6.7325C9.35244 6.99053 9.875 7.68522 9.875 8.5ZM6.125 8.5C6.125 7.68522 6.64756 6.99053 7.375 6.7325V8.75887L8.80791 10.1917C8.56309 10.3091 8.28912 10.375 8 10.375C6.96613 10.375 6.125 9.53387 6.125 8.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.125C5.84518 14.125 6.125 13.8452 6.125 13.5C6.125 13.1548 5.84518 12.875 5.5 12.875C5.15482 12.875 4.875 13.1548 4.875 13.5C4.875 13.8452 5.15482 14.125 5.5 14.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.375 12.875H11.125V14.125H7.375V12.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_17665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b61dcddd2c5aac66244d57a084531a93.svg";
export { ForwardRef as ReactComponent };